const AV = require('leancloud-storage')

AV.init({
  appId: 'hpANXByamhb5NqK6fpQy4zby-gzGzoHsz',
  appKey: 'VFiIgqyfA1TTjRaj5mAztjJr',
  serverURL: 'https://hpanxbya.lc-cn-n1-shared.com' // leancloud要求绑定备案的域名
})
export default AV
